
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telemedicine/categories",
      function () {
        return require("private-next-pages/telemedicine/categories.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telemedicine/categories"])
      });
    }
  